var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Const } from './provider/lib/const.cls';
import { mapActions } from 'vuex';
import { userOperation } from './lib/userOperation.cls';
import * as userOperationStoreExtensions from './provider';
var state = __assign({}, userOperationStoreExtensions.stateExt);
var actions = __assign({}, userOperationStoreExtensions.actionsExt);
var mutations = __assign({}, userOperationStoreExtensions.mutationsExt);
var getters = __assign({}, userOperationStoreExtensions.gettersExt);
// new store module definition
var userOperationStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module
export var userOperationMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[userOperation.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(userOperation.STORE_MODULE_NAME, userOperationStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({}, mapActions({
        //===================Order===========================
        _runGetIpAddressList: Const.RUN_GET_IP_ADDRESS_LIST,
        _runAddIpAddress: Const.RUN_ADD_IP_ADDRES,
        _runUpdateIpAddress: Const.RUN_UPDATE_IP_ADDRES,
        // ======================= Login Info =========================
        _runLoginInfo: Const.RUN_GET_LOGIN_INFO,
    })), { computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        } }),
    computed: {
        ipAddressList: function () { return this.computedCommonFunc(Const.GET_IP_ADDRESS_LIST); },
        loginInfo: function () { return this.computedCommonFunc(Const.GET_LOGIN_INFO); }
    }
};
export default userOperationMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/userOperation/index.ts
// module id = null
// module chunks = 